import { store } from "@csrc/redux/storeConfig/store"
import { env } from "@utils"

const DEFAULT_PUBLIC_LIBRARY_BASE_URL = 'https://library.flowdit.software/api'

export const canSharePublicLibrary = () => {
  const checklistSettings = store.getState().app.settings.checklist
  return (checklistSettings.library_enabled && checklistSettings.library_enabled !== "0") && (checklistSettings.library_can_share && checklistSettings.library_can_share !== "0")
}

export const publicLibraryUrl = () => {
  // Settings are absent until `/setting/all` has answered — and never load at all in
  // the standalone embed build, which talks to the public library API only. Falling
  // through to the env default (below) is the intended behaviour there.
  const checklistSettings = store.getState().app?.settings?.checklist
  return checklistSettings?.library_url
}

export const getPublicLibraryBaseUrl = () => {
  return (
    publicLibraryUrl() ||
    env('REACT_APP_PUBLIC_LIBRARY_BASE_URL', DEFAULT_PUBLIC_LIBRARY_BASE_URL)
  )
}